angular.module('ui2.0Directives')
    .directive('showPageTabs', ['$rootScope','showPage2DataTransformationService','formService','$timeout','$routeParams','$window', 'cliCommonService', function ($rootScope,showPage2DataTransformationService,formService,$timeout,$routeParams,$window, cliCommonService){
    return {
        restrict:'AE',
        $scope:{
            'data':'=?',
            'togglePropValue':'&',
            'showAdditionalTabsList':'=',
            'showInWorkspace':'=',
            'showDocTree':'=',
            'isdocTreeVisible':'&'
        },
        templateUrl :$rootScope.createHtmlUrl("ui2.0/directiveTemplates/showPageTabs.html"),
        link : function($scope,element,attrs){
            $scope.$on('$destroy', function() {
                updateTableData();
                updateTabLength();
                openDetailsTab();
            });

            var entityTypeId = urlToCodeMapper[$routeParams.entityName];
            $scope.showPage2DataTransformationService = showPage2DataTransformationService;

            $scope.hideTabs = false;
            if(($scope.pageType=='globalCreate' && [111, 67].indexOf(entityTypeId) > -1) || ($scope.pageType == 'create' && [67, 325].indexOf(entityTypeId) > -1)){
                $scope.hideTabs = true;
            }


            function addExtraDefaultTabs(...tabs) {
                try {
                    tabs.forEach(tab => {
                        tab && $scope.showPage2DataTransformationService.returnObj.leftTabInfo.push(tab)
                        tab && setDefaultTabInLocalStorage('add',tab)
                        // remove the tab from the list i.e leftTabList to avoid duplication
                        if (tab) {
                            $scope.showPage2DataTransformationService.returnObj.leftTabList = _.without($scope.showPage2DataTransformationService.returnObj.leftTabList, tab)
                        }
                    })
                }
                catch (e) {
                    console.log(e)
                }


            }
            // adding 2 more tabs  by default [contract documents,contract clauses], if present.
            // these 2 tabs should only be added at cdr show page.

            if ($scope.data.entityTypeId.values == 160) {
                // find the tab with label Contract Documents and Contract Clauses
                let tabsTobeAdded = [{id: 3909}, {id: 4283}].map(tab => {
                    return _.find($scope.showPage2DataTransformationService.returnObj.leftTabList, {id: tab.id})
                })

                tabsTobeAdded.length && addExtraDefaultTabs(...tabsTobeAdded)

            }
                attrs.tabInfo && ($scope.tabInfo = $scope.$eval(attrs.tabInfo));
                $scope.$root.showPageTabInfo1 = $scope.tabInfo;
                var updateTableData= $scope.$on("updateTabsData",function($event,data){
                    attrs.tabInfo && ($scope.tabInfo = $scope.$eval(attrs.tabInfo));
                    $scope.$root.showPageTabInfo1 = $scope.tabInfo;
                    if(data) {
                        var found = false
                        $scope.tabInfo.map(function (d) {
                            if (d.id == data.id) {
                                d.switchOff = data.switchOff;
                                found = true;
                            }
                            return d;
                        });
                        if(!found){
                            $scope.tabInfo.push(data);
                        }
                    }
                })
                $scope.shrinkTabHeader = false;
                $scope.rightoffset = 0;
                var openDetailsTab = $scope.$on('openDetailsTab',function(e,obj){
                    $scope.setselectedLeftTabIdx(obj.idx,obj.selectedTab,obj.statusFilter);
                });
                var openDeatilsTabFromDD = $scope.$on('openDeatilsTabFromDD',function(e,obj){
                    $scope.showSelectedTab(obj.selectedTab,obj.statusFilter);
                });

            $scope.mountMeetingMinutes = function(){
                let idsMountAt = ['#meeting-minutes-id-1','#meeting-minutes-id-2'];
                idsMountAt.map((mountAt)=>{
                    var interval = setInterval(()=>{
                        if($(mountAt).length && $rootScope.dataForReactMeetingMinutes) {
                            let propsToPass = $rootScope.dataForReactMeetingMinutes;
                            if(!$(mountAt).children().length){
                                window.reactComponents.mountDynamicComponent(mountAt,"MeetingMinutes",propsToPass);
                            }else{
                                window.sarc.channelBroadcast("MeetingMinutes",
                                      {
                                        actionType: "fetchNew"
                                      },
                                      "meetingMinutesSubscription"
                                    );
                                }
                                clearInterval(interval);
                            }
                        },300)
                })
            }
            $scope.setselectedLeftTabIdx = function (idx,selObj,statusFilter) {
                if(selObj.id === 1919){// lable id of meeting minutes is 1919
                    $scope.mountMeetingMinutes()
                }
                if(showPage2DataTransformationService.returnObj.selectedTabObj.id == selObj.id)
                    return; // Case when user clicks on current tab

                if($scope.showCommentPanelInRightSec) {
                    $('ng-view').fixedCommentPanel = !idx;
                }
                // saving selected tab/ breadcrumb in sessionStrg.
                 sessionStorage.setItem('selectedBreadcrumb',selObj.id);

                if (selObj.id == 4358 || selObj.id == 4549 || $scope.data.isCrcTab) {
                    cliCommonService.loadContractLineItemComponent(selObj);
                    $rootScope.contractLineItemLoaded = true;
                }
                if($scope.data.isCrcTab)
                    $rootScope.contractRateCardLoaded = true;
                if(selObj.id == 3909 && !$scope.contractDocTabDataUrl) {
                    const cdTab = selObj.fields.find(tab => tab.id == 3910);
                    cdTab && ($rootScope.contractDocTabDataUrl = cdTab.fields[0].dataURL);
                }

                showPage2DataTransformationService.returnObj.selectedTabObj=selObj;
                showPage2DataTransformationService.returnObj.selectedTabIndex=idx;
                $scope.contractClauseTab.isVisible = false;
                if(selObj.type == "contractClauseTab") {
                    $scope.contractClauseTab.isVisible = true
                    if($('.analytic-detailed-view .clause-deviation-view > div').is(":hidden") && !$('#noCDRDataToShow').length){
                        let errorMsg = intl_msg[29874] || 'We are analysing the clauses in the document.. Please wait.';
                        let noDataHtml = "<div id='noCDRDataToShow' class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 160px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\">" + errorMsg + "</span></div></div>";
                        $('.analytic-detailed-view .clause-deviation-view').append(noDataHtml);
                    }
                    $scope.openRightSection()
                }

                if(!$scope.documentOpenWithForm && ($scope.pageType != 'show') ) {
                    $scope.togglePropValue('expandLeftSection', true);
                    $scope.openRightSection()
                }
                if(selObj.properties?.analytics){
                    $rootScope.showAnalytics=true;
                    showPage2DataTransformationService.mountAnalyticsTab(selObj.id,$rootScope)
                }
                formService.alertMe(idx,selObj,statusFilter,$scope);
                $scope.openRightSection();
                $scope.$broadcast('updateTabLength');
            };

            $scope.toggleValue = function(a){
                $scope.togglePropValue(a);
            }
            $window.addEventListener('resize', _.debounce(function(){
                calculateTabWidth(element);},150)
            );
            $scope.showSelectedTab = function(obj,statusFilter){
                if((!$scope.oldTimeLineFeedScope || $scope.oldTimeLineFeedScope === -1)  && (!$scope.oldCommentDataScope || $scope.oldCommentDataScope === -1) && (!$scope.oldTagsOutlineFeedScope || $scope.oldTagsOutlineFeedScope === -1) ) {
                    $scope.oldTimeLineFeedScope = $scope.timeLineFeedScope;
                    $scope.oldCommentDataScope = $scope.commentDataScope;
                    $scope.oldTagsOutlineFeedScope = $scope.tagsOutlineFeedScope;
                }
                $scope.tabInfo.push(obj);
                $scope.togglePropValue('showAdditionalTabsList', false);
                let p1 = new Promise(function(resolve,reject){
                    $scope.setselectedLeftTabIdx(0,obj,statusFilter);
                    setDefaultTabInLocalStorage('add',obj);
                    _.remove(showPage2DataTransformationService.returnObj.leftTabList,function(o){return o.id == obj.id});
                    resolve('done');
                });
                p1.then(function(result){
                    calculateTabWidth(element);
                    if ($(".resizedIframeClass").length == 0) {
                        $timeout(function () {
                            resizeIframeOnTabLoad();
                        }, 500);
                    }
                });
            };

            $scope.checkForTabsDropRight = function(){
                var retval = false;
                if($scope.tabInfo.length == 1){
                    retval = true;
                    return retval;
                }
                var _width = $(".jx-tabs").width();
                var leftOffset = $(".jx-addTabs").offset().left;
                if(_width >= leftOffset){
                    retval = true;
                }
                return retval;
            };

            $scope.removeSelectedTab =function(obj){
                event.stopPropagation();
                let tabIdx = _.findIndex($scope.tabInfo,function(o){
                    return o.id == obj.id;
                });
                let p1 = new Promise(function(resolve,reject) {
                    if (showPage2DataTransformationService.returnObj.selectedTabObj.id == obj.id) {
                        let selectedTabIdx = tabIdx + 1 == $scope.tabInfo.length ? 0 : tabIdx + 1;
                        $scope.setselectedLeftTabIdx(0, $scope.tabInfo[selectedTabIdx]);
                    }
                    showPage2DataTransformationService.returnObj.leftTabList.push($scope.tabInfo[tabIdx]);
                    setDefaultTabInLocalStorage('remove',obj);
                    _.remove($scope.tabInfo, function (o) {
                        return o.id == obj.id
                    });
                    resolve('done');
                });
                p1.then(function(result){
                    calculateTabWidth(element);
                    $scope.togglePropValue('showAdditionalTabsList', false);
                });

            };

            /* Function to return count of visible tabs */
            $scope.getCountOfVisibleTabs = function(obj){
                return _.filter(obj,function(o){
                    return !o.switchOff;
                }).length;
            };
            /* Listener function of "updateTabLength" event : on collapse or expand of right section recalculate tab width  */
            var updateTabLength = $scope.$on('updateTabLength',function(event,val){
                $timeout(function(){
                    calculateTabWidth(element,val ? val.resetDocTree : null);
                    commonUtil.reAdjustAllColumnSize();
                },200);
            });

            /* Recalculation of tab width in case of tab info stored in localstorage */
            if(typeof localStorage !== 'undefined' && localStorage.getItem('defaultSelectedTab')){
                $timeout(function(){ calculateTabWidth(element);},100);
            }
            /* *************************************************************************************
               =============================  Private Functions ====================================
             ****************************************************************************************/

            /* **** setDefaultTabInLocalStorage ===> function to store the info about selected tabs in localstorage **/
            function setDefaultTabInLocalStorage(opn,obj){

                if (typeof localStorage !== 'undefined') {
                    var x = localStorage.getItem('defaultSelectedTab');
                    var tempObj;
                    if(!x){
                        //tempObj = [];
                        tempObj = {};
                        tempObj[entityTypeId] = [];

                    }else{
                        tempObj = JSON.parse(x);
                    }
                    if(opn == 'add' ) {
                        if (tempObj.hasOwnProperty(entityTypeId) && _.findIndex(tempObj[entityTypeId], function (o) {
                                return o.id == obj.id;
                            }) < 0) {
                            tempObj[entityTypeId].push(obj);
                        } else {
                            tempObj[entityTypeId] = [];
                            tempObj[entityTypeId].push(obj);
                        }

                    }else{
                        _.remove(tempObj[entityTypeId], function (o) {
                            return o.id == obj.id
                        });
                    }
                    if(tempObj[entityTypeId].length){
                        localStorage.setItem('defaultSelectedTab',JSON.stringify(tempObj));
                        let currTab = showPage2DataTransformationService.returnObj.selectedTabObj;
                        let isGeneralTab = formService.isGeneralTab(currTab);
                        if(!isGeneralTab && $scope.hasTimeLineFeed) {
                            // $scope.setTimelineFeedDataScope(-1);
                        }
                    }
                    else{
                        localStorage.removeItem('defaultSelectedTab');
                    }
                } else {
                    // localStorage not defined
                }
            }
            /* ****************************** End of setDefaultTabInLocalStorage************************/

            /* **** calculateTabWidth ===> function to calculate tab width on dynamic addition or deletion of tabs **/
            function calculateTabWidth(element,resetDocTreeWidth){
                if($routeParams.action=='show'){
                    /*if(resetDocTreeWidth){
                        $('#left_menu, .left-sec .tabs').width('auto');
                    }*/
                    resetTabWidth(element);
                    let elWidth = element.width(),
                        ulWidth = element.find('.jx-tabsUl').outerWidth(),
                        liMargin = parseInt(element.find('.jx-tabsUl').find('li').css('marginLeft'))+parseInt(element.find('.jx-tabsUl').find('li').css('marginRight')),
                        additionalTabsWidth =element.find('.jx-addTabs').length ? element.find('.jx-addTabs').outerWidth():0,
                        noOfLis = element.find('.jx-tabsUl').find(".jx-leftTabs:not(:first-child)").length  ,
                        firstLiWidth = element.find('.jx-leftTabs:first').outerWidth()+liMargin;

                    if((element.find('.jx-addTabs').length && ulWidth+element.find('.jx-addTabs').outerWidth() >= elWidth)||(!element.find('.jx-addTabs').length && element.find('.jx-tabsUl').outerHeight() > element.outerHeight())){
                        if(!element.find('.jx-addTabs').hasClass('shrink-tabs-list')){element.find('.jx-addTabs').addClass('shrink-tabs-list');}
                        ulWidth = ulWidth-(ulWidth+additionalTabsWidth-elWidth+firstLiWidth+20)-noOfLis*liMargin;
                        const tabs = element.find('.jx-tabsUl').find('.jx-leftTabs:not(:first-child)');
                        const tabMaxWidth = ulWidth/noOfLis;
                        if(tabs.length){
                            tabs.each((i,e)=>{
                                if($(e).outerWidth() > tabMaxWidth){
                                    $(e).attr('style','width:'+ tabMaxWidth + 'px');
                                }
                            });
                        }
                    }else{
                        resetTabWidth(element);
                    }

                }

            }
            /* ****************************** End of calculateTabWidth************************/

            /* **** resetTabWidth ===> function to reset tab width on dynamic addition or deletion of tabs **/
            function resetTabWidth(el){
                el.find('.jx-tabsUl').find('li').removeAttr('style');
                el.find('.jx-addTabs').removeClass('shrink-tabs-list');
            }
            /* ****************************** End of resetTabWidth************************/

        }
    }
}])
    .directive('multiTableHeader', ['$rootScope','$timeout',function($rootScope,$timeout){
        return{
            restrict :'AE',
            scope : {
                mtab : '='
            },
            templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/multiTableHeaders.html"),
            link: function(scope,elm,attrs){
                if(scope.mtab && (scope.mtab.type == "tabular" || scope.mtab.type == "tabs") && scope.mtab.fields && scope.mtab.fields.length){
                    scope.isValid = true;
                    scope.visLength = 0;

                    if(scope.mtab.id == 3907){
                        scope.isValid = false;
                    }

                    scope.mtab.fields = scope.mtab.fields.map((item,i)=> {
                        item.showOnMultiTable = false;
                        if( [1935, 1928].indexOf(item.id) > -1){
                            item.showActionVal =  $rootScope.actionEntityShowPermission;
                            item.showOnMultiTable = $rootScope.actionEntityShowPermission;
                        } else if([1936, 1929].indexOf(item.id)> -1){
                            item.showIssueVal = $rootScope.issueEntityShowPermission;
                            item.showOnMultiTable = $rootScope.issueEntityShowPermission;
                        }else if([4231, 4232].indexOf(item.id)> -1){
                            item.showDisputeVal = $rootScope.disputeEntityShowPermission ;
                            item.showOnMultiTable = $rootScope.disputeEntityShowPermission;
                        }else{
                            item.showOnMultiTable = true;
                        }
                        item.canShow = true;
                        item.active = i?false:true;
                        if(item.showActionVal === false){
                            item.active = false;
                        }else if(item.showIssueVal && !$rootScope.actionEntityShowPermission){
                            item.active = true;
                        }else if(item.showDisputeVal && !$rootScope.actionEntityShowPermission && !$rootScope.issueEntityShowPermission){
                            item.active = true;
                        }
                        if(!scope.isValid){
                            item.active = true;
                        }
                        return item;
                    })

                    scope.changeHeaderShow = function(id,flag){
                        scope.mtab.fields = scope.mtab.fields.map((item,i)=>{
                            if(item.id == id ) {
                                item.canShow = flag;
                            }
                            return item;
                        })
                        scope.setVisLength();
                    }

                    scope.setVisLength = function(){
                        scope.visLength = scope.mtab.fields.filter((item)=>{ return item.canShow;}).length;
                    }

                    scope.changeTab = function(id){
                        scope.mtab.fields = scope.mtab.fields.map((item,i)=>{
                            item.active = item.id==id?true:false;
                            return item;
                        })
                        var tblElm = $("#table_"+id+"_wrapper .dataTables_scrollBody [my-table]");
                        if(tblElm.length){
                            $timeout(()=>{
                                tblElm.dataTable().fnAdjustColumnSizing(false);
                            },200)
                        }
                    }

                    scope.setVisLength();

                    var cleanup1 = $rootScope.$on("change multi table tab visibility",function(e,obj,flag){
                        scope.changeHeaderShow(obj,flag);
                    })

                    scope.$on('$destroy', function() {
                        cleanup1();
                    });
                }
            }
        }
    }])
